"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * Commit changes of all list changes when experiment features are allowed
 * @param editor The Editor object
 * @param chains List chains to commit
 */
function experimentCommitListChains(editor, chains) {
    if ((chains === null || chains === void 0 ? void 0 : chains.length) > 0) {
        var range = editor.getSelectionRange();
        var start = range && roosterjs_editor_dom_1.Position.getStart(range);
        var end = range && roosterjs_editor_dom_1.Position.getEnd(range);
        chains.forEach(function (chain) { return chain.commit(); });
        editor.select(start, end);
    }
}
exports.default = experimentCommitListChains;
//# sourceMappingURL=experimentCommitListChains.js.map